/**
 * Social / share glyphs — the share menu's Copy Link icon and the Jobs "no match" card
 * (Flutter uses bundled assets for both; the other share options use the tenant `iconUrl`).
 * 24px grid, `currentColor`; filled brand marks and 1.8px-stroke utility icons at matching weight.
 */

const svgProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  'aria-hidden': true,
} as const;

const strokeProps = {
  ...svgProps,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function LinkIcon() {
  return (
    <svg {...strokeProps}>
      <path d="M10 14a4.5 4.5 0 0 0 6.36 0l3.18-3.18a4.5 4.5 0 0 0-6.36-6.36l-1.1 1.1" />
      <path d="M14 10a4.5 4.5 0 0 0-6.36 0l-3.18 3.18a4.5 4.5 0 0 0 6.36 6.36l1.1-1.1" />
    </svg>
  );
}

export function LinkedInIcon() {
  return (
    <svg {...svgProps} fill="currentColor">
      <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.75h4V21H3V9.75Zm6.5 0h3.83v1.54h.05c.53-1 1.84-2.06 3.78-2.06 4.04 0 4.79 2.66 4.79 6.12V21h-4v-5.1c0-1.22-.02-2.78-1.7-2.78-1.7 0-1.96 1.33-1.96 2.7V21h-4V9.75Z" />
    </svg>
  );
}

export function XIcon() {
  return (
    <svg {...svgProps} width={16} height={16} fill="currentColor">
      <path d="M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78L17.75 3Zm-1.08 16.2h1.7L7.4 4.73H5.58L16.67 19.2Z" />
    </svg>
  );
}

export function WhatsAppIcon() {
  return (
    <svg {...strokeProps}>
      <path d="M3.5 20.5l1.25-4.1A8.5 8.5 0 1 1 8.1 19.6l-4.6.9Z" />
      <path d="M9.2 8.3c-.2.9.1 2.2 1.2 3.4 1.2 1.3 2.6 2 3.6 1.9l.9-1.1-1.7-.9-.8.6a4 4 0 0 1-1.9-1.9l.6-.8-.9-1.7-1 .5Z" fill="currentColor" strokeWidth={1.2} />
    </svg>
  );
}

export function EmailIcon() {
  return (
    <svg {...strokeProps}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="m3.8 6.5 8.2 6 8.2-6" />
    </svg>
  );
}
